import styled from "styled-components";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { RadioGroup } from "@mui/material";

export const Title = styled.h6`
	font-weight: bold;
	font-size: 20;
`;
export const BodyBackground = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	width: 100%;

	& > * {
		width: 100%;
	}
`;
export const FooterBackground = styled.div``;

export const TitleGrid = styled.div`
	font-weight: bold;
	color: #000;
`;

export const IconExpandMore = styled(ExpandMore)`
	&&& {
		color: ${({ theme }) => theme.pantone2726C};
		font-size: 30px;
	}
`;

export const Spinner = styled.div`
	border: 3px solid rgba(0, 0, 0, 0.1);
	border-left-color: ${({ theme }) => theme.pantone2726C};
	border-radius: 50%;
	width: 20px;
	height: 20px;
	animation: spin 1s linear infinite;
	margin: 0 10px;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;

export const Background = styled.div`
	background-color: #eaeaea;
	padding: 10px 20px;
	min-height: 200px;

	> form {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
`;

export const ProgressContainer = styled.div`
	display: flex;
	align-items: center;
	margin: 20px;
`;

export const DownloadContainer = styled.div`
	display: flex;
	align-items: center;
	margin: 1rem 0;
	cursor: pointer;
`;

export const InfoContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const BoxModal = styled.div`
	background-color: #fff;
	border-radius: 8px;
	padding: 15px;
	width: 90%;
`;

export const TitleModal = styled.div`
	font-weight: bold;
	font-size: 14px;
`;

export const TitleGridModal = styled.div`
	font-weight: bold;
	font-size: 14px;
	margin-top: 0.5rem;
`;

export const LabelModal = styled.div`
	margin-top: 0.5rem;
`;

export const ContainerTitleGrid = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const LabelAlert = styled.div`
	font-weight: bold;
	font-size: 13px;
	color: ${({ theme }) => theme.red};
`;

export const CustomRadioGroup = styled(RadioGroup)`
	&&& {
		display: flex;
		flex-direction: row;
		justify-content: center;
		gap: 1rem;
		margin: 1rem 0;
		flex-wrap: nowrap;
		width: 100%;

		> .MuiFormControlLabel-root {
			margin: 0;
			> .MuiRadio-root {
				padding: 0 0.4rem 0 0;
			}
		}
	}
`;

interface ICustomColumn {
	$width?: string;
}
export const CustomColumn = styled.div<ICustomColumn>`
	width: 100%;
	max-width: ${({ $width }) => $width || "100%"};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
